import { ReuseModal } from "../../ReuseModal";
import { useState } from "react";
import { GradeBlock } from "./GradeBody";
import { FormBody } from "./FormBody";
import { useAddFeedbackMutation } from "../../../../api";
import { FeedbackMessages, FeedbackScores } from "../../../../types/apiTypes";
import { toast } from "react-toastify";
import { CustomToast } from "../../CustomToast";
import { getErrorMessage } from "../../../../utils/getErrorMessage";

export const FeedbackModal = ({
  isOpen,
  setIsOpen,
}: {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}) => {
  const [files, setFiles] = useState<File[]>([]);
  const [currentStep, setCurrentStep] = useState<number>(0);
  const [isError, setIsError] = useState<boolean>(false);
  const [formData, setFormData] = useState<FeedbackScores>({
    impression_score: null,
    accuracy_score: null,
    business_flows_score: null,
    expectations_score: null,
  });

  const [feedbackMessages, setFeedbackMessages] = useState<FeedbackMessages>({
    feedback: "",
  });

  const [addFeedback, { isLoading }] = useAddFeedbackMutation();

  const changeStepHandler = (step: number) => {
    setCurrentStep(step);
  };

  const isGradeForm = currentStep === 0;

  const onSubmit = () => {
    if (isGradeForm) {
      changeStepHandler(1);
    } else {
      addFeedback({
        files,
        ...formData,
        feedback: feedbackMessages.feedback,
        functionality_suggestion:
          feedbackMessages.functionality_suggestion || undefined,
      })
        .unwrap()
        .then(() => {
          toast.success(
            <CustomToast
              type="success"
              text="Thank you! Your feedback has been submitted successfully."
              title="Feedback sent"
            />,
          );
          setIsOpen(false);
        })
        .catch((error) =>
          toast.error(
            <CustomToast
              type="error"
              text={
                getErrorMessage(error).globalError ||
                "Something went wrong. Please try submitting your feedback again."
              }
              title="Submission failed"
            />,
          ),
        );
    }
  };

  const onCancel = () => {
    if (isGradeForm) {
      setIsOpen(false);
    } else {
      changeStepHandler(0);
    }
  };

  return (
    <ReuseModal
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
      onCancel={onCancel}
      title="Submit Feedback"
      maxWidth="540px"
      onSubmit={onSubmit}
      submitBtnText={
        isGradeForm
          ? Object.values(formData).some((el) => el && el > 0)
            ? "Next"
            : "Skip"
          : "Submit"
      }
      cancelBtnText={isGradeForm ? "Cancel" : "Back"}
      submitBtnColor="#1C3C6C"
      isDisabled={
        (!isGradeForm && !feedbackMessages.feedback) ||
        isLoading ||
        (!isGradeForm && isError)
      }
      isLoading={isLoading}
      isDisabledCancelBtn={isLoading}
    >
      {isGradeForm && (
        <GradeBlock
          gradeData={formData}
          nextStepHandler={() => changeStepHandler(1)}
          setGradeData={setFormData}
        />
      )}
      <FormBody
        setIsError={setIsError}
        setFeedbackMessages={setFeedbackMessages}
        setFiles={setFiles}
        isShowed={!isGradeForm}
        isLoading={isLoading}
      />
    </ReuseModal>
  );
};
